export const formatDobToDisplay = (dob: string | undefined | null): string => {
  if (!dob) return "";

  // Check if already in dd/mm/yyyy format

  // Check if in YYYY-MM-DD format and convert
  if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
    const [year, month, day] = dob.split("-");
    return `${month}/${day}/${year}`;
  }

  // Return as-is if format is unrecognized
  return dob;
};

/**
 * Formats an ISO timestamp (e.g., 2025-12-15T08:31:59.544052Z) to mm/dd/yyyy format.
 */
export const formatTimestampToDisplay = (
  timestamp: string | undefined | null,
): string => {
  if (!timestamp) return "--";

  // Handle ISO timestamp format (e.g., 2025-12-15T08:31:59.544052Z)
  const dateMatch = timestamp.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (dateMatch) {
    const [, year, month, day] = dateMatch;
    return `${month}/${day}/${year}`;
  }

  // Return as-is if format is unrecognized
  return timestamp;
};
